import React from "react";
import Divider from "@mui/material/Divider";
import styles from "./verticalDivider.module.scss";
const VerticalDivider = ({ id }) => {
    return (React.createElement(Divider, { id: id, orientation: "vertical", flexItem: true, className: styles.root }));
};
export default VerticalDivider;
//# sourceMappingURL=VerticalDivider.js.map